import React from "react";
import { FiPackage } from "react-icons/fi";
import Button from "./Button";
import classNames from "./classNames";

const EmptyState = ({
  icon: Icon = FiPackage,
  title = "Nothing here yet",
  description,
  actionLabel,
  actionTo,
  onAction,
  className,
}) => (
  <section className={classNames("empty-state", className)} aria-live="polite">
    {Icon && <Icon className="empty-state__icon" aria-hidden="true" />}
    <h2 className="empty-state__title">{title}</h2>
    {description && <p className="empty-state__description">{description}</p>}
    {actionLabel && (
      <Button className="empty-state__action" to={actionTo} onClick={onAction}>
        {actionLabel}
      </Button>
    )}
  </section>
);

export default EmptyState;
